import { render, staticRenderFns } from "./CustomerInvoices.vue?vue&type=template&id=13da41ad&scoped=true&"
import script from "./CustomerInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoices.vue?vue&type=style&index=0&id=13da41ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da41ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13da41ad')) {
      api.createRecord('13da41ad', component.options)
    } else {
      api.reload('13da41ad', component.options)
    }
    module.hot.accept("./CustomerInvoices.vue?vue&type=template&id=13da41ad&scoped=true&", function () {
      api.rerender('13da41ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/CustomerInvoices.vue"
export default component.exports